<template>
  <b-modal
    :id="`edit-company-${id}`"
    :title="`${this.$t('menu.masterSettings.titleEditCompany')}`"
    size="lg"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @ok="save"
    @hidden="cancel"
  >
    <div class="row">
      <div class="col-xl-6">
        <div class="form-group">
          <label for="corporate-name-modal"
            >{{ this.$t('menu.masterSettings.labels.companyName') }}:</label
          >
          <input
            type="text"
            v-model="company.corporateName"
            id="corporate-name-modal"
            class="form-control"
            :placeholder="`${this.$t(
              'menu.masterSettings.placeholderCorporationName',
            )}`"
            @keyup="removeInvalidClass('corporate-name-modal')"
          />
          <div class="invalid-feedback">
            {{ this.$t('menu.masterSettings.feedbackInformCorporationName') }}
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="form-group">
          <label for="company-name-modal"
            >{{ this.$t('menu.masterSettings.labels.fantasyName') }}:</label
          >
          <input
            type="text"
            v-model="company.name"
            id="company-name-modal"
            class="form-control"
            :placeholder="`${this.$t(
              'menu.masterSettings.placeholderCompanyName',
            )}`"
            @keyup="removeInvalidClass('company-name-modal')"
          />
          <div class="invalid-feedback">
            {{ this.$t('menu.masterSettings.feedbackInformCompanyName') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <div class="form-group">
          <label for="company-cnpj-modal"
            >{{ this.$t('menu.masterSettings.labels.cnpj') }}:</label
          >
          <input
            type="text"
            v-model="company.cnpj"
            id="company-cnpj-modal"
            class="form-control"
            :placeholder="`${this.$t('menu.masterSettings.placeholderCnpj')}`"
            v-mask="'##.###.###/####-##'"
            @keyup="removeInvalidClass('company-cnpj-modal')"
          />
          <div class="invalid-feedback">
            {{ this.$t('menu.masterSettings.feedbackInformCnpj') }}
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="form-group">
          <label for="company-segment-modal"
            >{{ this.$t('menu.masterSettings.labels.sequence') }}:</label
          >
          <input
            type="text"
            v-model="mySegment"
            id="company-segment-modal"
            class="form-control"
            :placeholder="`${this.$t(
              'menu.masterSettings.placeholderSequence',
            )}`"
            @keyup="searchSegment"
          />
          <div
            id="options-segment-modal"
            class="options-segment"
            style="display: none;"
          >
            <ul v-for="(segment, i) in filterSegments" :key="i">
              <li @click="chooseSegment(segment)">{{ segment }}</li>
            </ul>
          </div>
          <div class="invalid-feedback">
            {{ this.$t('menu.masterSettings.feedbackInformSequence') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <div class="form-group">
          <label for="company-country-modal"
            >{{ this.$t('menu.masterSettings.labels.country') }}:</label
          >
          <input
            type="text"
            v-model="country"
            id="company-country-modal"
            class="form-control"
            :placeholder="`${this.$t(
              'menu.masterSettings.placeholderCountry',
            )}`"
          />
        </div>
      </div>
      <div class="col-xl-6">
        <div class="form-group">
          <label for="company-reference-modal"
            >{{ this.$t('menu.masterSettings.labels.referenceDate') }}:</label
          >
          <input
            type="text"
            v-model="referenceDate"
            id="company-reference-modal"
            class="form-control"
            :placeholder="`${this.$t(
              'menu.masterSettings.placeholderReference',
            )}`"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <div class="form-group">
          <label for="user-profile-modal"
            >{{ this.$t('menu.masterSettings.labels.plan') }}:</label
          >
          <b-form-select
            v-model="plan.myPlan"
            id="select-plan-modal"
            :options="plan.options"
          >
          </b-form-select>
          <div class="invalid-feedback">
            {{ this.$t('menu.masterSettings.feedbackInformBalance') }}
          </div>
        </div>
      </div>
      <div class="col-xl-6 button-area">
        <div v-if="plan.myPlan === 'personalizado'" class="form-group">
          <label for="sms-balance-modal"
            >{{ this.$t('menu.masterSettings.labels.smsMonth') }}:</label
          >
          <input
            type="number"
            v-model="plan.qtySms"
            id="sms-balance-modal"
            class="form-control"
          />
        </div>
        <div v-if="plan.myPlan === 'personalizado'" class="form-group ml-3">
          <label for="email-balance-modal"
            >{{ this.$t('menu.masterSettings.labels.emailMonth') }}:</label
          >
          <input
            type="number"
            v-model="plan.qtyEmail"
            id="email-balance-modal"
            class="form-control"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <div class="form-group">
          <label for="expirate-time-password">Expiração de senha</label>
          <b-form-select
            v-model="expirateTimePassword"
            id="expirateTimePassword"
            :options="expirateTimePasswordOptions"
          >
          </b-form-select>
        </div>
      </div>
      <div class="col-xl-6">
        <label>Autenticação de 2 fatores</label>

        <div class="form-group custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            id="enable-two-factor"
            v-model="enableTwoFactor"
          />
          <label class="custom-control-label" for="enable-two-factor">
            Habilitar recurso
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="company-name"
            >{{ this.$t('menu.masterSettings.labels.companyLogo') }}:</label
          >
          <b-form-file
            browse-text="Logo"
            :placeholder="`${this.$t('menu.masterSettings.placeholderLogo')}`"
            :drop-placeholder="`${this.$t(
              'menu.masterSettings.placeholderDropFile',
            )}`"
            name="image"
            v-model="logo"
          ></b-form-file>
        </div>
      </div>
    </div>
    <div class="row custom-switch mt-2">
      <div class="col-12">
        <input
          type="checkbox"
          class="custom-control-input"
          id="switch-sentiment"
          v-model="enableSentiment"
        />
        <label class="custom-control-label" for="switch-sentiment">
          {{ this.$t('menu.masterSettings.labels.sentiment') }}
        </label>
      </div>
      <div class="col-12">
        <input
          type="checkbox"
          class="custom-control-input"
          id="switch-enable-anexo"
          v-model="enableAttach"
        />
        <label class="custom-control-label" for="switch-enable-anexo">
          {{ this.$t('menu.masterSettings.labels.enableAttach') }}
        </label>
      </div>
      <div class="col-12">
        <input
          type="checkbox"
          class="custom-control-input"
          id="switch-enable-audio"
          v-model="enableAudioResponse"
        />
        <label class="custom-control-label" for="switch-enable-audio">
          {{ this.$t('menu.masterSettings.labels.enableAudioResponse') }}
        </label>
      </div>
      <div class="col-12">
        <input
          type="checkbox"
          class="custom-control-input"
          id="switch-enable-totem"
          v-model="channelTotem"
        />
        <label class="custom-control-label" for="switch-enable-totem">
          {{ $t('menu.masterSettings.labels.channelTotem') }}
        </label>
      </div>
      <!-- <div class="col-12">
        <input
          type="checkbox"
          class="custom-control-input"
          id="switch-enable-call-center"
          v-model="channelCallCenter"
        />
        <label class="custom-control-label" for="switch-enable-call-center">
          {{ $t('menu.masterSettings.labels.channelCallCenter') }}
        </label>
      </div> -->
      <div class="col-12">
        <input
          type="checkbox"
          class="custom-control-input"
          id="switch-enable-rounding"
          v-model="enableRounding"
        />
        <label class="custom-control-label" for="switch-enable-rounding">
          Arredondar Nps
        </label>
      </div>
    </div>
    <div
      class="screen"
      id="screen-modal"
      @click="closeInputSegments"
      style="display: none;"
    />
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import swal from 'sweetalert';

export default {
  props: ['id', 'myCompany', 'filter', 'page'],

  data: () => ({
    userAuth: null,
    company: null,
    logo: null,
    mySegment: null,
    plan: {
      myPlan: null,
      options: [],
      qtyEmail: 0,
      qtySms: 0,
    },
    filterSegments: [],
    isSave: false,
    enableSentiment: false,
    enableAttach: false,
    enableAudioResponse: false,
    channelTotem: false,
    channelCallCenter: false,
    enableRounding: false,
    country: 'Brasil',
    referenceDate: null,
    expirateTimePassword: 0,
    enableTwoFactor: false,
    expirateTimePasswordOptions: [
      { text: 'A cada 30 dias', value: 30 },
      { text: 'A cada 45 dias', value: 45 },
      { text: 'A cada 60 dias', value: 60 },
      { text: 'A cada 90 dias', value: 90 },
      { text: 'Nunca expirar', value: 0 },
    ],
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.company = {
      ...this.myCompany,
    };
    this.plan.myPlan = this.myCompany.plan.type;
    this.mySegment = this.myCompany.segment;
    this.plan.qtyEmail = this.myCompany.plan.qtyEmail;
    this.plan.qtySms = this.myCompany.plan.qtySms;
    this.enableSentiment = this.myCompany.enableSentimentAnalyze;
    this.enableAttach = this.myCompany.enableAttachTreatments;
    this.enableAudioResponse = this.myCompany.enableAudioResponse
      ? true
      : false;
    this.channelTotem = this.myCompany.channelTotem ? true : false;
    this.channelCallCenter = this.myCompany.channelCallCenter ? true : false;
    this.enableRounding = this.myCompany.arred ? true : false;
    this.country = this.myCompany.country;
    this.referenceDate = this.myCompany.referenceDate;
    this.expirateTimePassword = this.myCompany.expirateTimePassword || 0;
    this.enableTwoFactor = this.myCompany.enableTwoFactor || false;

    this.plan.options = [
      {
        value: 'demo',
        text: this.$t('menu.masterSettings.channelOptions.demo'),
      },
      {
        value: 'basico',
        text: this.$t('menu.masterSettings.channelOptions.basic'),
      },
      {
        value: 'intermediario',
        text: this.$t('menu.masterSettings.channelOptions.intermediate'),
      },
      {
        value: 'avancado',
        text: this.$t('menu.masterSettings.channelOptions.advanced'),
      },
      {
        value: 'personalizado',
        text: this.$t('menu.masterSettings.channelOptions.custom'),
      },
      { value: 'dev', text: this.$t('menu.masterSettings.channelOptions.dev') },
    ];
  },

  computed: {
    ...mapFields('master', ['loading']),
    ...mapState('master', ['segments']),
  },

  methods: {
    ...mapActions('master', ['updateCompany', 'getCompanies']),

    async updateTable() {
      this.loading = true;

      await this.getCompanies({
        token: this.userAuth.token,
        page: this.page,
        filter: this.filter,
      });

      this.loading = false;
    },

    save(event) {
      if (this.validateFields()) {
        this.isSave = true;

        this.updateCompany({
          token: this.userAuth.token,

          companyId: this.company._id,
          data: {
            corporateName: this.company.corporateName,
            name: this.company.name,
            cnpj: this.company.cnpj,
            segment: this.mySegment,
            plan: {
              type: this.plan.myPlan,
              qtyEmail: this.plan.qtyEmail || 0,
              qtySms: this.plan.qtySms || 0,
            },
            file: this.logo,
            enableSentimentAnalyze: this.enableSentiment,
            enableAttachTreatments: this.enableAttach,
            enableAudioResponse: this.enableAudioResponse ? true : false,
            channelTotem: this.channelTotem ? true : false,
            channelCallCenter: this.channelCallCenter ? true : false,
            arred: this.enableRounding ? true : false,
            country: this.country,
            referenceDate: this.referenceDate,
            expirateTimePassword: this.expirateTimePassword,
            enableTwoFactor: this.enableTwoFactor,
          },
        })
          .then(() => {
            this.updateTable();
            swal({
              title: 'Alterações Salvas!',
              text: `As alterações para a empresa ${this.company.name} foram salvas com sucesso!`,
              icon: 'success',
            });
          })
          .catch(() => {});
      } else {
        event.preventDefault();
      }
    },

    cancel() {
      if (!this.isSave) {
        this.company = {
          ...this.myCompany,
        };
        this.plan.myPlan = this.myCompany.plan.type;
        this.mySegment = this.myCompany.segment;
        this.plan.qtyEmail = this.myCompany.plan.qtyEmail;
        this.plan.qtySms = this.myCompany.plan.qtySms;
        this.enableSentiment = this.myCompany.enableSentimentAnalyze;
        this.enableAttach = this.myCompany.enableAttachTreatments;
        this.enableAudioResponse = this.myCompany.enableAudioResponse
          ? true
          : false;
        this.channelTotem = this.myCompany.channelTotem ? true : false;
        this.channelCallCenter = this.myCompany.channelCallCenter
          ? true
          : false;
        this.enableRounding = this.myCompany.arred ? true : false;
        this.country = this.myCompany.country;
        this.referenceDate = this.myCompany.referenceDate;
      }

      this.isSave = false;
    },

    searchSegment(event) {
      this.removeInvalidClass(event.target.id);
      this.filterSegments = [];
      const myString = this.replaceSpecialChars(
        event.target.value.toLowerCase(),
      );

      for (let i = 0; i < this.segments.length; i += 1) {
        let segment = this.segments[i].toLowerCase();
        segment = this.replaceSpecialChars(segment);
        if (segment.indexOf(myString) !== -1) {
          this.filterSegments.push(this.segments[i]);
        }
      }

      document.getElementById('options-segment-modal').style.display = 'block';
      document.getElementById('screen-modal').style.display = 'block';
    },

    chooseSegment(segment) {
      this.mySegment = segment;

      document.getElementById('options-segment-modal').style.display = 'none';
      document.getElementById('screen-modal').style.display = 'none';
    },

    replaceSpecialChars(str) {
      const myString = str
        .replace(/[àáâãäå]/, 'a')
        .replace(/[éèê]/, 'e')
        .replace(/[íìî]/, 'i')
        .replace(/[óòô]/, 'o')
        .replace(/[úùû]/, 'u')
        .replace(/[ç]/, 'c');
      return myString;
    },

    closeInputSegments() {
      this.mySegment = null;
      document.getElementById('options-segment-modal').style.display = 'none';
      document.getElementById('screen-modal').style.display = 'none';
    },

    validateFields() {
      if (!this.company.corporateName) {
        document
          .getElementById('corporate-name-modal')
          .classList.add('is-invalid');
        return false;
      } else if (!this.company.name) {
        document
          .getElementById('company-name-modal')
          .classList.add('is-invalid');
        return false;
      } else if (!this.company.cnpj) {
        document
          .getElementById('company-cnpj-modal')
          .classList.add('is-invalid');
        return false;
      } else if (!this.mySegment) {
        document
          .getElementById('company-segment-modal')
          .classList.add('is-invalid');
        return false;
      } else if (!this.plan.myPlan) {
        return false;
      }

      if (
        this.plan.myPlan === 'personalizado' &&
        (!this.plan.qtySms || !this.plan.qtyEmail)
      ) {
        document
          .getElementById('select-plan-modal')
          .classList.add('is-invalid');
        return false;
      }

      return true;
    },

    removeInvalidClass(id) {
      const element = document.getElementById(id);
      for (let i = 0; i <= element.classList.length; i += 1) {
        if (element.classList[i] === 'is-invalid') {
          element.classList.remove('is-invalid');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.options-segment {
  max-height: 200px;
  overflow: auto;
  padding: 5px;
  position: absolute;
  z-index: 10;
  background-color: #fff;
  width: (100% - 7%);
  box-shadow: 0 5px 8px -5px rgba(0, 0, 0, 0.57);

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 5px 13px;
      font-weight: 500;
      cursor: pointer;
    }

    li:hover {
      background-color: $gray-lighter;
    }
  }
}

.button-area {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-height: 86px;

  input {
    max-width: 100px;
  }
}

.screen {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/master/modal-edit-company/index.vue